import React from 'react';
import {
  alpha,
  createTheme,
  Box,
  Card,
  CardActions,
  Divider,
  SvgIcon,
  Button,
  TextField,
  MenuItem,
  Tooltip
} from '@mui/material';
import { CircularProgress, Paper, Typography } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import BarChartIcon from '@mui/icons-material/BarChart';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Chart from './chart';
import Client from '../Client';
import Config from '../ClientConfig';
import BackofficeReportsApi from './backofficeReportsApi';
import BackOfficeConfig from '../../Config';
import { format } from 'date-fns';

let theme = createTheme();

const objectToCsv = function (data) {
  const csvRows = [];
  const headers = Object.keys(data[0]);
  csvRows.push(headers.join(','));

  for (const row of data) {
    const values = headers.map(header => {
      const val = row[header];
      return `"${val}"`;
    });
    csvRows.push(values.join(','));
  }

  return csvRows.join('\n');
};

function thousandsSeparator(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function generateYearsBetween(startYear = 2000, endYear) {
  const endDate = endYear || new Date().getFullYear();
  let years = [];

  while (startYear <= endDate) {
    years.push(startYear);
    startYear++;
  }

  return years;
}

let end = 0;
let start = 0;

end = new Date().getFullYear();
start = end - 3;

const yearsArray = generateYearsBetween(start, end);
yearsArray.reverse();

let years = {};
years = yearsArray.map(x => ({ value: x }));

const now0 = new Date();
now0.setHours(0, 0, 0, 0);
const now = now0;
const csvdate = format(now, 'yyyy-MM-dd');

class OverviewClassSales extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      client: new Client("none"),
      location: 0,
      pclass: 0,
      pcategory: 0,
      delivery: 2,
      year: new Date().getFullYear(),
      value: "1",
      locations: [{ 'iref': 0, 'name': "All Locations" }],
      pclasses: [{ 'iref': 0, 'name': "All Classes" }],
      pcategorys: [{ 'iref': 0, 'name': "All Categories" }],
      deliverys: [{ 'iref': 2, 'name': "All" }, { 'iref': 0, 'name': "Restaurant" }, { 'iref': 1, 'name': "Delivery" }],
      filterData: {},
      busyOverlay: false,
    };

    this.getData = this.getData.bind(this);
    this.doSync = this.doSync.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.selectYear = this.selectYear.bind(this);
    this.selectLocation = this.selectLocation.bind(this);
    this.selectClass = this.selectClass.bind(this);
    this.selectCategory = this.selectCategory.bind(this);
    this.selectDelivery = this.selectDelivery.bind(this);

    this.queryData = {};

    this.showOverlay = this.showOverlay.bind(this);
    this.hideOverlayMin = this.hideOverlayMin.bind(this);
    this.getDataWithOverlay = this.getDataWithOverlay.bind(this);
    this._overlayShownAt = 0;
  }

  componentDidMount() {
    this.getDataWithOverlay();
  }

  getData() {
    let queryData = {
      "location": this.state.location,
      "location_status": 1,
      "delivery": this.state.delivery,
      "class": this.state.pclass,
      "category": this.state.pcategory,
      "year": this.state.year,
      "hasForSale": 1,
      "orderBy_name": true
    };

    let data = BackofficeReportsApi.getSalesClassLocationTimeseries(this.state.client, queryData);

    if (data) {
      this.setState({ sales_month: data });
    }

    this.setState({ filterData: queryData });

    let locations = BackofficeReportsApi.getLocations(this.state.client);
    this.setState({ locations: locations.locations });

    let pclasses = this.state.client.getData(Config.API_URL_PRODUCT_CLASS, queryData);
    this.setState({ pclasses: pclasses.productClasses });

    let pcategorys = this.state.client.getData(Config.API_URL_PRODUCT_CATEGORY, queryData);
    this.setState({ pcategorys: pcategorys.productCategories });
  }

  doSync() {
    this.getDataWithOverlay();
  }

  selectYear = (event) => {
    this.setState(
      { year: event.target.value },
      function () {
        this.doSync();
      }
    );
  }

  selectLocation = (event) => {
    this.setState(
      { location: event.target.value },
      function () {
        this.doSync();
      }
    );
  }

  selectClass = (event) => {
    this.setState(
      { pclass: event.target.value },
      function () {
        this.doSync();
      }
    );
  }

  selectCategory = (event) => {
    this.setState(
      { pcategory: event.target.value },
      function () {
        this.doSync();
      }
    );
  }

  selectDelivery = (event) => {
    this.setState(
      { delivery: event.target.value },
      function () {
        this.doSync();
      }
    );
  }

  handleChange = (event, newValue) => {
    this.setState({ value: newValue });
  }

  onDownload = () => {
    const link = document.createElement("a");
    let csvData = 0;

    link.download = "salesClassesOverview_" + csvdate + ".csv";

    if (this.state.sales_month) {
      csvData = objectToCsv(this.state.sales_month.sales);
    }

    let csvHeader = "Sales Classes Overview\nLocations: " + this.state.location + "\nClass: " + this.state.class;
    let csv = "\uFEFF" + csvHeader + "\n" + csvData;

    link.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
    link.click();
  };

  async showOverlay() {
    this.setState({ busyOverlay: true });
    await new Promise(requestAnimationFrame);
    await new Promise(requestAnimationFrame);
    this._overlayShownAt = performance.now();
  }

  hideOverlayMin() {
    const MIN_VISIBLE = 400;
    const elapsed = performance.now() - (this._overlayShownAt || 0);
    const hide = () => this.setState({ busyOverlay: false });

    if (elapsed < MIN_VISIBLE) {
      setTimeout(hide, MIN_VISIBLE - elapsed);
    } else {
      hide();
    }
  }

  async getDataWithOverlay() {
    await this.showOverlay();

    try {
      this.getData();
    } finally {
      this.hideOverlayMin();
    }
  }

  render() {
    let deliverys = [
      { 'iref': 2, 'name': "All" },
      { 'iref': 0, 'name': "Restaurant" },
      { 'iref': 1, 'name': "Delivery" }
    ];

    let locations = [{ 'iref': 0, 'name': "All Locations" }];

    if (this.state.locations) {
      Object.keys(this.state.locations).forEach(key => {
        let fData = this.state.locations[key];
        let myData = { 'iref': fData.iref, 'name': fData.name };
        locations.push(myData);
      });
    }

    let pclasses = [{ 'iref': 0, 'name': "All Classes" }];

    if (this.state.pclasses) {
      Object.keys(this.state.pclasses).forEach(key => {
        let fData = this.state.pclasses[key];
        let myData = { 'iref': fData.iref, 'name': fData.name };
        pclasses.push(myData);
      });
    }

    let pcategorys = [{ 'iref': 0, 'name': "All Categories" }];

    if (this.state.pcategorys) {
      Object.keys(this.state.pcategorys).forEach(key => {
        let fData = this.state.pcategorys[key];
        let myData = { 'iref': fData.iref, 'name': fData.name };
        pcategorys.push(myData);
      });
    }

    let sales = [];
    let salesT = [];
    let salesA = [];
    let salesD = [];
    let salesD_LY = [];
    let salesM_new = [];
    let salesM_LY_new = [];
    let salesW = [];
    let salesW_LY = [];
    let salesW_trans = [];
    let salesW_LY_trans = [];
    let salesM_new_trans = [];
    let salesM_LY_new_trans = [];

    if (this.state.sales_month) {
      if (this.state.sales_month.sales) {
        Object.keys(this.state.sales_month.sales).forEach(key => {
          let fData = this.state.sales_month.sales[key];
          let sign = "";

          if (fData.month < 10) {
            sign = "-0";
          } else {
            sign = "-";
          }

          let myData = { 'x': fData.year + sign + fData.month, 'y': fData.total };
          sales.push(myData);

          let myTrans = { 'x': fData.year + sign + fData.month, 'y': fData.trans };
          salesT.push(myTrans);

          let myAvg = { 'x': fData.year + sign + fData.month, 'y': fData.total / fData.trans };
          salesA.push(myAvg);
        });
      }

      if (this.state.sales_month.salesD) {
        let days = "";

        Object.keys(this.state.sales_month.salesD).forEach(key => {
          days = BackOfficeConfig.WEEKDAYS_EN[parseInt(key) + 1];
          let fData = this.state.sales_month.salesD[key];
          let myData = { 'x': days, 'y': fData.total / fData.count };
          salesD.push(myData);
        });
      }

      if (this.state.sales_month.salesD_LY) {
        let days = "";

        Object.keys(this.state.sales_month.salesD_LY).forEach(key => {
          days = BackOfficeConfig.WEEKDAYS_EN[parseInt(key) + 1];
          let fData = this.state.sales_month.salesD_LY[key];
          let myData = { 'x': days, 'y': fData.total / fData.count };
          salesD_LY.push(myData);
        });
      }

      if (this.state.sales_month.salesM_new) {
        Object.keys(this.state.sales_month.salesM_new).forEach(key => {
          let fData = this.state.sales_month.salesM_new[key];

          let myData = { 'x': fData.month, 'y': fData.value };
          salesM_new.push(myData);

          let myTrans = { 'x': fData.month, 'y': fData.trans };
          salesM_new_trans.push(myTrans);
        });
      }

      if (this.state.sales_month.salesM_LY_new) {
        Object.keys(this.state.sales_month.salesM_LY_new).forEach(key => {
          let fData = this.state.sales_month.salesM_LY_new[key];

          let myData = { 'x': fData.month, 'y': fData.value };
          salesM_LY_new.push(myData);

          let myTrans = { 'x': fData.month, 'y': fData.trans };
          salesM_LY_new_trans.push(myTrans);
        });
      }

      if (this.state.sales_month.salesW) {
        Object.keys(this.state.sales_month.salesW).forEach(key => {
          let fData = this.state.sales_month.salesW[key];

          let myData = { 'x': fData.week, 'y': fData.value };
          salesW.push(myData);

          let myTrans = { 'x': fData.week, 'y': fData.trans };
          salesW_trans.push(myTrans);
        });
      }

      if (this.state.sales_month.salesW_LY) {
        Object.keys(this.state.sales_month.salesW_LY).forEach(key => {
          let fData = this.state.sales_month.salesW_LY[key];

          let myData = { 'x': fData.week, 'y': fData.value };
          salesW_LY.push(myData);

          let myTrans = { 'x': fData.week, 'y': fData.trans };
          salesW_LY_trans.push(myTrans);
        });
      }
    }

    let maxM_LY_new = Math.max(...salesM_LY_new.map(({ y }) => y));
    let maxM_new = Math.max(...salesM_new.map(({ y }) => y));
    let maxM = parseInt(Math.max(maxM_LY_new, maxM_new));
    let p1 = maxM.toString().length - 1;
    maxM = Math.ceil(maxM / 10 ** p1) * 10 ** p1;

    let maxM_LY_new_trans = Math.max(...salesM_LY_new_trans.map(({ y }) => y));
    let maxM_new_trans = Math.max(...salesM_new_trans.map(({ y }) => y));
    let maxM_trans = parseInt(Math.max(maxM_LY_new_trans, maxM_new_trans));
    let p2 = maxM_trans.toString().length - 1;
    maxM_trans = Math.ceil(maxM_trans / 10 ** p2) * 10 ** p2;

    let maxW_LY = Math.max(...salesW_LY.map(({ y }) => y));
    let maxW = Math.max(...salesW.map(({ y }) => y));
    let maxW_LY_trans = Math.max(...salesW_LY_trans.map(({ y }) => y));
    let maxW_trans = Math.max(...salesW_trans.map(({ y }) => y));
    let maxWm = parseInt(Math.max(maxW_LY, maxW));
    let p3 = maxWm.toString().length - 1;
    maxWm = Math.ceil(maxWm / 10 ** p3) * 10 ** p3;

    let maxWm_trans = parseInt(Math.max(maxW_LY_trans, maxW_trans));
    let p4 = maxWm_trans.toString().length - 1;
    maxWm_trans = Math.ceil(maxWm_trans / 10 ** p4) * 10 ** p4;

    const chartHeight =
      window.innerWidth < 600
        ? 320
        : window.innerWidth < 1200
          ? 380
          : 430;

    const controlSx = {
      '& .MuiInputBase-root': {
        minHeight: 38,
        borderRadius: '12px',
        fontSize: {
          xs: '0.82rem',
          sm: '0.88rem',
        },
        bgcolor: '#fff',
      },
      '& .MuiInputLabel-root': {
        fontSize: {
          xs: '0.78rem',
          sm: '0.84rem',
        },
      },
      '& .MuiSelect-select': {
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },
    };

    const smallControlSx = {
      ...controlSx,
      width: {
        xs: 'calc(50% - 6px)',
        sm: 100,
      },
    };

    const mediumControlSx = {
      ...controlSx,
      width: {
        xs: 'calc(50% - 6px)',
        sm: 180,
      },
    };

    return (
      <Card
        variant="outlined"
        sx={{
          position: 'relative',
          width: '100%',
          height: {
            xs: 600,
            sm: 600,
            md: 620,
            lg: 640,
          },
          maxHeight: {
            xs: 600,
            sm: 600,
            md: 620,
            lg: 640,
          },
          minHeight: 0,
          borderRadius: {
            xs: '14px',
            sm: '16px',
          },
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '0 4px 14px rgba(15, 23, 42, 0.08)',
          border: '1px solid rgba(15, 23, 42, 0.06)',
          bgcolor: '#fff',
        }}
      >
        <Box
          sx={{
            px: {
              xs: 0.75,
              sm: 1,
            },
            py: {
              xs: 0.65,
              sm: 0.85,
            },
            flexShrink: 0,
            borderBottom: '1px solid rgba(15, 23, 42, 0.06)',
            bgcolor: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: {
                xs: 'stretch',
                sm: 'center',
              },
              justifyContent: 'space-between',
              gap: {
                xs: 0.75,
                sm: 1,
              },
              flexDirection: {
                xs: 'column',
                sm: 'row',
              },
            }}
          >
            <Box sx={{ minWidth: 0 }}>
              <Typography
                sx={{
                  color: '#1a237e',
                  fontWeight: 800,
                  fontSize: {
                    xs: '0.9rem',
                    sm: '1rem',
                  },
                  lineHeight: 1.2,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                Class Sales Overview
              </Typography>

              <Typography
                sx={{
                  mt: 0.15,
                  color: '#64748b',
                  fontWeight: 600,
                  fontSize: {
                    xs: '0.72rem',
                    sm: '0.78rem',
                  },
                  lineHeight: 1.2,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                Sales by class, category, location and delivery type
              </Typography>
            </Box>

            <Tabs
              value={this.state.value}
              onChange={this.handleChange}
              aria-label="class sales overview tabs"
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              sx={{
                minHeight: 36,
                maxWidth: {
                  xs: '100%',
                  sm: 360,
                },
                '& .MuiTabs-flexContainer': {
                  gap: 0.5,
                },
                '& .MuiTabs-indicator': {
                  display: 'none',
                },
                '& .MuiTab-root': {
                  minHeight: 34,
                  minWidth: {
                    xs: 58,
                    sm: 70,
                  },
                  px: {
                    xs: 1,
                    sm: 1.25,
                  },
                  py: 0,
                  borderRadius: 999,
                  textTransform: 'none',
                  fontWeight: 750,
                  fontSize: {
                    xs: '0.76rem',
                    sm: '0.84rem',
                  },
                  color: '#64748b',
                  border: '1px solid transparent',
                },
                '& .MuiTab-root.Mui-selected': {
                  color: '#1a237e',
                  bgcolor: 'rgba(26, 35, 126, 0.08)',
                  borderColor: 'rgba(26, 35, 126, 0.14)',
                },
              }}
            >
              <Tab icon={<BarChartIcon sx={{ fontSize: 18 }} />} value="1" />
              <Tab label="Month" value="2" />
              <Tab label="Week" value="3" />
              <Tab label="wDay" value="4" />
            </Tabs>
          </Box>

          <Box
            sx={{
              mt: 0.85,
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'center',
              gap: {
                xs: 0.75,
                sm: 1,
              },
              maxHeight: {
                xs: 150,
                sm: 112,
                md: 96,
              },
              overflowY: 'auto',
              overflowX: 'hidden',
              pr: 0.25,
              '&::-webkit-scrollbar': {
                width: 8,
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: 'rgba(15, 23, 42, 0.18)',
                borderRadius: 999,
              },
              '&::-webkit-scrollbar-track': {
                backgroundColor: 'rgba(15, 23, 42, 0.04)',
              },
            }}
          >
            <TextField
              id="standard-select-years"
              select
              defaultValue={end}
              variant="outlined"
              size="small"
              sx={smallControlSx}
              onChange={this.selectYear}
            >
              {years.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.value}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              id="standard-select-location"
              select
              defaultValue="0"
              variant="outlined"
              size="small"
              sx={mediumControlSx}
              onChange={this.selectLocation}
            >
              {locations.map((option) => (
                <MenuItem key={option.iref} value={option.iref}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              id="standard-select-class"
              select
              defaultValue="0"
              variant="outlined"
              size="small"
              sx={mediumControlSx}
              onChange={this.selectClass}
            >
              {pclasses.map((option) => (
                <MenuItem key={option.iref} value={option.iref}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              id="standard-select-category"
              select
              defaultValue="0"
              variant="outlined"
              size="small"
              sx={mediumControlSx}
              onChange={this.selectCategory}
            >
              {pcategorys.map((option) => (
                <MenuItem key={option.iref} value={option.iref}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              id="standard-select-delivery"
              select
              defaultValue="2"
              variant="outlined"
              size="small"
              sx={smallControlSx}
              onChange={this.selectDelivery}
            >
              {deliverys.map((option) => (
                <MenuItem key={option.iref} value={option.iref}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField>
          </Box>
        </Box>

        <Box
          sx={{
            flex: '1 1 auto',
            minHeight: 0,
            overflow: 'auto',
            bgcolor: '#fff',
            p: {
              xs: 0.75,
              sm: 1,
            },
            '&::-webkit-scrollbar': {
              height: 8,
              width: 8,
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: 'rgba(15, 23, 42, 0.18)',
              borderRadius: 999,
            },
            '&::-webkit-scrollbar-track': {
              backgroundColor: 'rgba(15, 23, 42, 0.04)',
            },
          }}
        >
          <Box
            sx={{
              borderRadius: '14px',
              border: '1px solid rgba(15, 23, 42, 0.06)',
              overflow: 'hidden',
              bgcolor: '#fff',
              minWidth: {
                xs: 540,
                sm: '100%',
              },
              minHeight: {
                xs: 330,
                sm: 390,
                md: 430,
                lg: 460,
              },
            }}
          >
            {this.state.value === "1" && (
              <Chart
                height={chartHeight}
                type="line01"
                series={[
                  {
                    name: 'Monthly sales',
                    type: 'bar',
                    data: sales
                  },
                  {
                    name: 'Monthly transactions',
                    type: 'line',
                    data: salesT
                  },
                  {
                    name: 'Average transaction',
                    type: 'line',
                    data: salesA
                  }
                ]}
                yaxis={[
                  {
                    seriesName: 'Monthly sales',
                    axisTicks: {
                      show: true
                    },
                    axisBorder: {
                      show: true,
                    }
                  },
                  {
                    seriesName: 'Monthly transactions',
                    axisTicks: {
                      show: true
                    },
                    axisBorder: {
                      show: true,
                    }
                  },
                  {
                    seriesName: 'Average transaction',
                    axisTicks: {
                      show: true
                    },
                    axisBorder: {
                      show: true,
                    }
                  }
                ]}
                width="100%"
              />
            )}

            {this.state.value === "2" && (
              <Chart
                height={chartHeight}
                type="line11"
                options={{
                  chart: {
                    background: 'transparent',
                    stacked: false,
                    toolbar: {
                      show: false,
                      offsetX: 0,
                      offsetY: 0,
                      tools: {
                        download: true,
                        selection: true,
                        zoom: true,
                        zoomin: true,
                        zoomout: true,
                        pan: true,
                        reset: true | '<img src="/static/icons/reset.png" width="20">',
                        customIcons: []
                      }
                    },
                    export: {
                      csv: {
                        filename: undefined,
                        columnDelimiter: ',',
                        headerCategory: 'category',
                        headerValue: 'value',
                        dateFormatter(timestamp) {
                          return new Date(timestamp).toDateString();
                        }
                      },
                      svg: {
                        filename: undefined,
                      },
                      png: {
                        filename: undefined,
                      }
                    },
                    zoom: {
                      enabled: false,
                      type: 'x',
                      autoScaleYaxis: false,
                      zoomedArea: {
                        fill: {
                          color: '#90CAF9',
                          opacity: 0.4
                        },
                        stroke: {
                          color: '#0D47A1',
                          opacity: 0.4,
                          width: 1
                        }
                      }
                    }
                  },
                  colors: [alpha(theme.palette.primary.main, 0.25), theme.palette.primary.main],
                  dataLabels: {
                    enabled: false
                  },
                  fill: {
                    opacity: 1,
                    type: 'solid'
                  },
                  grid: {
                    borderColor: theme.palette.divider,
                    strokeDashArray: 2,
                    xaxis: {
                      lines: {
                        show: false
                      }
                    },
                    yaxis: {
                      lines: {
                        show: true
                      }
                    }
                  },
                  legend: {
                    show: false
                  },
                  plotOptions: {
                    bar: {
                      horizontal: false,
                      columnWidth: '70%',
                      barHeight: '70%',
                      distributed: false,
                      colors: {
                        backgroundBarColors: Array
                      }
                    }
                  },
                  stroke: {
                    colors: [alpha(theme.palette.primary.main, 0.25), theme.palette.primary.main],
                    show: true,
                    curve: 'smooth',
                    lineCap: 'square',
                    width: 2
                  },
                  theme: {
                    mode: theme.palette.mode
                  },
                  xaxis: {
                    tickPlacement: 'on',
                    type: 'numeric',
                    tickAmount: 'dataPoints',
                    axisBorder: {
                      color: theme.palette.divider,
                      show: true
                    },
                    axisTicks: {
                      color: theme.palette.divider,
                      show: true
                    },
                    labels: {
                      offsetY: 2,
                      formatter: (value) => {
                        return value.toFixed(0);
                      },
                      style: {
                        colors: theme.palette.text.secondary
                      }
                    }
                  },
                  markers: {
                    size: [0, 0, 3, 3]
                  },
                  yaxis: [
                    {
                      seriesName: 'Last year Value',
                      show: true,
                      min: 0,
                      max: maxM,
                      labels: {
                        formatter: (value) => (value > 1000 ? `${thousandsSeparator((value / 1000).toFixed(1))}K` : `${value.toFixed(2)}`),
                        offsetX: -10,
                      }
                    },
                    {
                      seriesName: 'This year Value',
                      show: false,
                      min: 0,
                      max: maxM,
                      labels: {
                        formatter: (value) => (value > 1000 ? `${thousandsSeparator((value / 1000).toFixed(1))}K` : `${value.toFixed(2)}`),
                        offsetX: -10,
                        style: {
                          colors: theme.palette.text.secondary
                        }
                      }
                    },
                    {
                      seriesName: 'Last year Transactions',
                      opposite: true,
                      min: 0,
                      max: maxM_trans,
                      labels: {
                        formatter: (value) => (value > 1000 ? `${thousandsSeparator((value / 1000).toFixed(1))}K` : `${value.toFixed(2)}`),
                        offsetX: -10,
                        style: {
                          colors: theme.palette.text.secondary
                        }
                      }
                    },
                    {
                      seriesName: 'This year Transactions',
                      opposite: true,
                      show: false,
                      min: 0,
                      max: maxM_trans,
                      labels: {
                        formatter: (value) => (value > 1000 ? `${thousandsSeparator((value / 1000).toFixed(1))}K` : `${value.toFixed(2)}`),
                        offsetX: -10,
                        style: {
                          colors: theme.palette.text.secondary
                        }
                      }
                    }
                  ]
                }}
                series={[
                  {
                    name: 'Last year Value',
                    data: salesM_LY_new,
                    type: 'bar'
                  },
                  {
                    name: 'This year Value',
                    data: salesM_new,
                    type: 'bar'
                  },
                  {
                    name: 'Last year Transactions',
                    data: salesM_LY_new_trans,
                    type: 'line'
                  },
                  {
                    name: 'This year Transactions',
                    data: salesM_new_trans,
                    type: 'line',
                  }
                ]}
                width="100%"
              />
            )}

            {this.state.value === "3" && (
              <Chart
                height={chartHeight}
                type="line11"
                options={{
                  chart: {
                    background: 'transparent',
                    stacked: false,
                    toolbar: {
                      show: false,
                      offsetX: 0,
                      offsetY: 0,
                      tools: {
                        download: true,
                        selection: true,
                        zoom: true,
                        zoomin: true,
                        zoomout: true,
                        pan: true,
                        reset: true | '<img src="/static/icons/reset.png" width="20">',
                        customIcons: []
                      }
                    },
                    export: {
                      csv: {
                        filename: undefined,
                        columnDelimiter: ',',
                        headerCategory: 'category',
                        headerValue: 'value',
                        dateFormatter(timestamp) {
                          return new Date(timestamp).toDateString();
                        }
                      },
                      svg: {
                        filename: undefined,
                      },
                      png: {
                        filename: undefined,
                      }
                    },
                    zoom: {
                      enabled: false,
                      type: 'x',
                      autoScaleYaxis: false,
                      zoomedArea: {
                        fill: {
                          color: '#90CAF9',
                          opacity: 0.4
                        },
                        stroke: {
                          color: '#0D47A1',
                          opacity: 0.4,
                          width: 1
                        }
                      }
                    }
                  },
                  colors: [alpha(theme.palette.primary.main, 0.25), theme.palette.primary.main],
                  dataLabels: {
                    enabled: false
                  },
                  fill: {
                    opacity: 1,
                    type: 'solid'
                  },
                  grid: {
                    borderColor: theme.palette.divider,
                    strokeDashArray: 2,
                    xaxis: {
                      lines: {
                        show: false
                      }
                    },
                    yaxis: {
                      lines: {
                        show: true
                      }
                    }
                  },
                  legend: {
                    show: false
                  },
                  plotOptions: {
                    bar: {
                      horizontal: false,
                      columnWidth: '70%',
                      barHeight: '70%',
                      distributed: false,
                      colors: {
                        backgroundBarColors: Array
                      }
                    }
                  },
                  stroke: {
                    colors: [alpha(theme.palette.primary.main, 0.25), theme.palette.primary.main],
                    show: true,
                    curve: 'smooth',
                    lineCap: 'square',
                    width: 2
                  },
                  theme: {
                    mode: theme.palette.mode
                  },
                  xaxis: {
                    tickPlacement: 'on',
                    type: 'numeric',
                    tickAmount: 'dataPoints',
                    axisBorder: {
                      color: theme.palette.divider,
                      show: true
                    },
                    axisTicks: {
                      color: theme.palette.divider,
                      show: true
                    },
                    labels: {
                      offsetY: 2,
                      formatter: (value) => {
                        return value.toFixed(0);
                      },
                      style: {
                        colors: theme.palette.text.secondary
                      }
                    }
                  },
                  markers: {
                    size: [0, 0, 3, 3]
                  },
                  yaxis: [
                    {
                      seriesName: 'Last year Value',
                      show: true,
                      min: 0,
                      max: maxWm,
                      labels: {
                        formatter: (value) => (value > 1000 ? `${thousandsSeparator((value / 1000).toFixed(1))}K` : `${value.toFixed(2)}`),
                        offsetX: -10,
                      }
                    },
                    {
                      seriesName: 'This year Value',
                      show: false,
                      min: 0,
                      max: maxWm,
                      labels: {
                        formatter: (value) => (value > 1000 ? `${thousandsSeparator((value / 1000).toFixed(1))}K` : `${value.toFixed(2)}`),
                        offsetX: -10,
                        style: {
                          colors: theme.palette.text.secondary
                        }
                      }
                    },
                    {
                      seriesName: 'Last year Transactions',
                      opposite: true,
                      min: 0,
                      max: maxWm_trans,
                      labels: {
                        formatter: (value) => (value > 1000 ? `${thousandsSeparator((value / 1000).toFixed(1))}K` : `${value.toFixed(2)}`),
                        offsetX: -10,
                        style: {
                          colors: theme.palette.text.secondary
                        }
                      }
                    },
                    {
                      seriesName: 'This year Transactions',
                      opposite: true,
                      show: false,
                      min: 0,
                      max: maxWm_trans,
                      labels: {
                        formatter: (value) => (value > 1000 ? `${thousandsSeparator((value / 1000).toFixed(1))}K` : `${value.toFixed(2)}`),
                        offsetX: -10,
                        style: {
                          colors: theme.palette.text.secondary
                        }
                      }
                    }
                  ]
                }}
                series={[
                  {
                    name: 'Last year Value',
                    data: salesW_LY,
                    type: 'bar'
                  },
                  {
                    name: 'This year Value',
                    data: salesW,
                    type: 'bar'
                  },
                  {
                    name: 'Last year Transactions',
                    data: salesW_LY_trans,
                    type: 'line'
                  },
                  {
                    name: 'This year Transactions',
                    data: salesW_trans,
                    type: 'line'
                  }
                ]}
                width="100%"
              />
            )}

            {this.state.value === "4" && (
              <Chart
                height={chartHeight}
                type="bar1"
                series={[
                  {
                    name: 'Daily sales Last Year',
                    data: salesD_LY
                  },
                  {
                    name: 'Daily sales This Year',
                    data: salesD
                  }
                ]}
                width="100%"
              />
            )}
          </Box>
        </Box>

        <Divider />

        <CardActions
          sx={{
            flexShrink: 0,
            justifyContent: 'flex-end',
            px: {
              xs: 0.75,
              sm: 1,
            },
            py: {
              xs: 0.65,
              sm: 0.85,
            },
            borderTop: '1px solid rgba(15, 23, 42, 0.06)',
            bgcolor: '#fff',
          }}
        >
          <Tooltip title="Download CSV">
            <Button
              color="inherit"
              endIcon={(
                <SvgIcon fontSize="small">
                  <ArrowForwardIcon />
                </SvgIcon>
              )}
              size="small"
              onClick={this.onDownload}
              variant="contained"
              sx={{
                height: 36,
                borderRadius: '12px',
                color: '#1a237e',
                bgcolor: 'rgba(26, 35, 126, 0.08)',
                boxShadow: 'none',
                border: '1px solid rgba(26, 35, 126, 0.12)',
                textTransform: 'none',
                fontWeight: 750,
                '&:hover': {
                  bgcolor: 'rgba(26, 35, 126, 0.12)',
                  boxShadow: 'none',
                },
              }}
            >
              Download
            </Button>
          </Tooltip>
        </CardActions>

        {this.state.busyOverlay && (
          <Box
            role="status"
            aria-live="polite"
            sx={{
              position: 'absolute',
              inset: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 9999,
              pointerEvents: 'auto',
              bgcolor: 'rgba(15, 23, 42, 0.16)',
              backgroundImage:
                'radial-gradient(ellipse at center, rgba(15, 23, 42, 0.08) 0%, rgba(15, 23, 42, 0.18) 75%, rgba(15, 23, 42, 0.22) 100%)',
            }}
          >
            <Paper
              elevation={3}
              sx={{
                px: 2.5,
                py: 1.5,
                borderRadius: '14px',
                bgcolor: 'background.paper',
                color: 'text.primary',
                display: 'flex',
                alignItems: 'center',
                gap: 1.25,
                border: '1px solid rgba(15, 23, 42, 0.08)',
              }}
            >
              <CircularProgress size={22} color="inherit" />
              <Typography variant="body2">Preparing report…</Typography>
            </Paper>
          </Box>
        )}
      </Card>
    );
  }
}

export default OverviewClassSales;
